'use strict';

import { action, observable, flow, makeObservable } from "mobx";
import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import appStore from "@uw-it-sis/lib-react/lib/AppStore";

class ImportSocialPlanStore {
    state = States.initial;

    history = {};

    constructor() {
        makeObservable(this, {
            state: observable,
            history: observable,
            mount: action
        });
        this.exceptionUtils = appStore.getExceptionUtils();
    }

    mount() {
        this._loadData();
    }

    _loadData = flow(function* () {
        this.state = States.pending;

        // Build url for the ajax call
        let url = 'api/socialImport/history';

        try {
            this.history = yield appStore.getHttpClient().doGet(url, 'getSocialImportHistory');
            if (appStore.isDevMode()) {
                console.log('ImportSocialPlanStore: Data load complete');
            }

            this.state = States.done;
        } catch(error) {
            this.exceptionUtils.handleException(error, "ImportSocialPlanStore.loadData");
            this.state = States.error;
        }
    })

    /*
     * This requests the login url from the app api and redirects the browser to that url
     * @param type must be either 'google' or 'facebook'
     */
    doLogin = flow(function* (type) {
        this.state = States.pending;

        try {
            const url = `api/socialImport/login/${type}`

            // This is the url the user will be returned to after logging in with the IdP
            const returnUrl = `${window.location.origin}/plan/#/import/confirm`

            const headers = {
                "x-sis-relaystate": returnUrl,
            }

            const response = yield appStore.getHttpClient().sendRequest("get", url, null, headers, 'start social login');

            window.location = response.url;
            this.state = States.done;
        } catch (error) {
            this.exceptionUtils.handleException(error, "ImportSocialPlanStore.loadData");
            this.state = States.error;
        }
    })
}

export default new ImportSocialPlanStore();
